<template>
  <div class="top-menu">
    <div class="atest">
    <a href="https://www.lefisc.com.br/">
    <img width="120vw" height="25vh" class="logo-menu" src="https://www.lefisc.com.br/monitoramentoncm/img/logo.png" alt="lefisc_logo">
    </a>
      <div class="titulo-menu">
      <router-link :to="{name:'Home'}">
      <p>{{ titulo }}</p>
    </router-link>
    </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      titulo: "Benefício Emergencial - Simulador de Cálculo",
    }
  }
};
</script>

<style>

.atest {
  display:flex;
  align-items: center;
  position: relative;
  width:1170px;
  height: 60px;
  margin: 0 auto;
  background: #fff;
}

.top-menu {  
  top: 0;
  left: 0;
  width: 100%;
  height: 60px;
  background: #fff;
}

.logo-menu {
  border-right: 1px solid rgb(0,0,0,0.5);
  padding-right: 10px;
  flex-grow: 0;
}

.titulo-menu p {
  margin: 0 0 0 10px;
  font-size: 15px;
  font-weight: 700;
  color: #383838;
  flex-grow: 1;
}
</style>